let containerTimelineJourneyVM = {};

function assignContainerTimelineJourneyVM() {
  containerTimelineJourneyVM = {
    Containers: ko.observableArray(),
    Steps: ko.observableArray(), // Container Placement Array
    enableprev: ko.observable(false),
    enablenext: ko.observable(false),
  };
}

function formatDate(date) {
  if (!date) {
    return '';
  }
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [month, day, year].join('-');
}

function formatFinanceDate(date) {
  if (!date) {
    return '';
  }
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join('-');
}

const initContainerTimelineJourney = () => {
  if ($('#component-timeline-journey').length > 0) {
    ko.applyBindings(containerTimelineJourneyVM, document.getElementById('component-timeline-journey'));
  }

  refreshContainers();
};

function refreshContainers(flag) {
  if ($('#component-timeline-journey').length > 0 && window.customerOrders.Orders) {
    const orderObj = window.customerOrders.Orders;

    generateContainers(orderObj);
    feather.replace();
    $('[data-toggle="tooltip"]').tooltip();

    // Reinitialize DatePicker After Submitting Move Leg
    if (flag == false) {
      addDatePicker();
    }

    $('.ZipCode').each(function () {
      const postalCode = $(this).val();

      if (postalCode.length > 0) {
        if ($(this).closest('.component-timeline_journey-card').find('.datepicker.valid').length) {
          enableContainerPlacement($(this));
          enableSubmitIfValid();
        }
      }
    });

    setupCityStateSubmit();
    setupAddressValidation();
    setupMoveLegSubmit();
    setupGoogleApiAddressAutocomplete();
  }

  if (flag != undefined) {
    $('.datepicker').datepicker().on('changeDate', function () {
      $('.component-timeline_journey-card.active').find('.submitScheduleForm').removeClass('disabled');
    });
  }
  
}

// Containers Observables Defination

let ko_Container = function (container) {
  const self = this;

  if (container) {
    self.orderId = ko.observable(container.OrderId);
    self.quoteId = ko.observable(container.QuoteId);
    self.price = ko.observable(container.Price);
    self.orderDateFormatted = ko.observable(container.OrderDateFormatted);
    self.isCityService = ko.observable(container.IsCityService);
    self.legNumberLabel = ko.observable(container.OrderNumberLabel);
    self.containerType = ko.observable(container.ContainerType);
    self.containerId = ko.observable(container.ContainerId);
    self.etaDays = ko.observable(container.ETADays);
    self.etaDaysText = ko.observable(container.ETADaysText);
    self.containerImg = ko.observable(container.ContainerImageSrc);
    self.containerImgAlt = ko.observable(container.ContainerImageAlt);
    self.moveLegs = ko.observableArray();
    self.togglePrevText = ko.observable(false);
    self.toggleNextText = ko.observable(false);
    self.showUpcomingText = ko.observable(container.ShowUpcomingText);
    self.showPreviousText = ko.observable(container.ShowPreviousText);
    self.hideUpcomingText = ko.observable(container.HideUpcomingText);
    self.hidePreviousText = ko.observable(container.HidePreviousText);
    self.moveLegTemplate = function (moveLeg) {
      return moveLeg.legKnockoutTemplateName();
    };
    self.toggleShowHide = function(data, ev) {
      let visibleMoveLegs = $(ev.currentTarget).closest('.component-timeline_journey').find('.component-timeline_journey-card[data-active=true]');

      if (data == 'prev') {
        visibleMoveLegs.first().prevAll().toggleClass('d-none');
        this.togglePrevText(!this.togglePrevText());
      } else if (data == 'next') {
        visibleMoveLegs.last().nextAll().toggleClass('d-none');
        this.toggleNextText(!this.toggleNextText());
      }
    };
    self.legFormVisible = ko.observable(false);
    self.legFormType = ko.observable();
  }
};

const ko_Legs = function (leg, container) {
  const self = this;

  if (leg) {
    self.cancel = (data, ev) => {};
    self.container = container;
    self.legKnockoutTemplateName = ko.observable(leg.MoveLegKnockoutTemplateName);
    self.legEta = ko.observable(leg.ETA);
    self.legId = ko.observable(leg.MoveLegId);
    self.legStatus = ko.observable(leg.MoveLegStatus);
    self.legType = ko.observable(leg.MoveLegType);
    self.warehouseCode = ko.observable(leg.WarehouseCode);
    self.legScheduledDate = ko.observable(formatDate(leg.ScheduledDate));
    self.legScheduledDateFormatted = ko.observable(leg.ScheduledDateFormatted);
    self.legTransitDays = ko.observable(leg.TransitDays);
    self.legActive = ko.observable(leg.isActive);
    self.legNextStep = ko.observable(leg.isNextStep);
    self.legTitle = ko.observable(leg.MoveLegTitle);
    self.legDescription = ko.observable(leg.MoveLegDescription);
    self.legDateLabel = ko.observable(leg.MoveLegDateLabel);
    self.legPickupDetails = ko.observable(leg.MovePickupDetails);
    self.legToolTip = ko.observable(leg.MoveToolTip);
    self.legWindowLabel = ko.observable(leg.MoveLegWindowLabel);
    self.legAddressLabel = ko.observable(leg.MoveLegAddressLabel);
    self.legDeliveryAddress = ko.observable(leg.Address);
    self.legAvailabilityOriginZip = ko.observable(leg.AvailabilityOriginZip);
    self.legAvailabilityOriginCountry = ko.observable(leg.AvailabilityOriginCountry);
    self.legAvailabilityDestinationZip = ko.observable(leg.AvailabilityDestinationZip);
    self.legAvailabilityDestinationCountry = ko.observable(leg.AvailabilityDestinationCountry);
    self.legEdit = ko.observable(leg.isEdit);
    self.legCityService = ko.observable(leg.isCityService);
    self.legInlineForm = ko.observable(leg.isInlineForm);
    self.legScheduleForm = ko.observable(leg.isScheduleForm);
    self.legPodsTip = ko.observable(leg.isPodsTip);
    self.legContainerPlacement = ko. observable(leg.isContainerPlacement);
    self.editDetailsHelpText = ko.observable(leg.EditDetailsHelpText);
    self.loadFinance = ko.observable(leg.LoadFinance);
    self.financeTag = ko.observable();
    if(leg.LoadFinance) {
      self.financeTag = ko.observable('<acorn-mypods-widget linkOnly id="acorn-mypods-widget"></acorn-mypods-widget>');
    }
    self.loadPaymentAmountWidget = function loadPaymentAmountWidget() {
      setTimeout(function(){
        if(acornParameters != undefined && acornParameters != null) {
          acornParameters.loanAmount = self.container.price()
          acornParameters.merCustomerId = window.customerOrders.UserId
          acornParameters.merRefId = self.container.quoteId() //Use prefix POD- with suffix PODS's Quote Number (PAW will set utm_content to this value too)
          acornParameters.merOrderId = self.container.orderId()
          acornParameters.merDeliveryDate = formatFinanceDate(leg.ScheduledDate)
          acornParameters.hideWidget = false // false or null or none, true (optional overrides the merDeliveryDate logic)
          acornParameters.utm_source = 'MyPODS-Orders'
          acornParameters.docSource = 'MyPODS-Orders'
          if(window.customerOrders.User != null){
            acornParameters.personalInfo = {
              firstname: window.customerOrders.User.FirstName,
              lastName: window.customerOrders.User.LastName,
              email: window.customerOrders.User.Email,
              phonenumber: window.customerOrders.User.PhoneNumber,
              city: window.customerOrders.User.City, 
              state: window.customerOrders.User.State,
              streetaddress: window.customerOrders.User.Address,
              apartment: window.customerOrders.User.Apartment,
              zipcode: window.customerOrders.User.Zipcode
            }
          }
          setAcornWidget('acorn-mypods-widget');
        }
      }, 300)
		}

    if (leg.isPodsTip) {
      self.podsTipIconSrc = ko.observable(leg.PodsTip.IconSrc);
      self.podsTipIconAlt = ko.observable(leg.PodsTip.IconAlt);
      self.podsTipTitle = ko.observable(leg.PodsTip.TitleText);
      self.podsTipDescription = ko.observable(leg.PodsTip.HelpText);
    }

    if (leg.isNextStep) {
      self.nextStepTitle = ko.observable(leg.NextStepTitle);
      self.nextStepDescription = ko.observable(leg.NextStepDescription);
      self.nextStepCtaText = ko.observable(leg.NextStepCtaText);
    }

    if (leg.isEdit) {
      self.editDetailsCtaText = ko.observable(leg.EditDetailsCtaText);
    }

    if (leg.isScheduleForm || leg.MoveLegKnockoutTemplateName === 'visitform-ml-template') {
      self.scheduleTitle = ko.observable(leg.ScheduleTitle);
      self.scheduleDescription = ko.observable(leg.ScheduleDescription);
      self.scheduleLocationTitle = ko.observable(leg.ScheduleLocationTitle);
      self.scheduleDateLabel = ko.observable(leg.ScheduleDateLabel);
      self.scheduleDateInformation = ko.observable(leg.ScheduleDateInformation);
      self.scheduleConfirmButtonLabel = ko.observable(leg.ScheduleConfirmButtonLabel);
      self.scheduleCancelButtonLabel = ko.observable(leg.ScheduleCancelButtonLabel);
      self.scheduleDateHelperLabel = ko.observable(leg.ScheduleDateHelperLabel);
      self.additionalChargeConfirmationMessageText = ko.observable(leg.AdditionalChargeConfirmationMessageText);
      self.refundConfirmationMessageText = ko.observable(leg.RefundConfirmationMessageText);
      self.confirmationButtonText = ko.observable(leg.ConfirmationButtonText);
      self.disableWindow = ko.observable(leg.DisableWindow);  
      self.reschedulingWindow = ko.observable(leg.ReschedulingWindow);

      if (leg.AccessContainerDateHeader) {
        self.accessContainerDateHeader = ko.observable(leg.AccessContainerDateHeader);
        self.orText = ko.observable(leg.OrText);
        self.cancelVisitCtaText = ko.observable(leg.CancelVisitCtaText);
        self.nevermindCancelVisitCtaText = ko.observable(leg.NevermindCancelVisitCtaText);
        self.previousScheduledDateFormatted = ko.observable(leg.PreviousScheduledDateFormatted);
        self.previousLegDateLabel = ko.observable(leg.PreviousLegDateLabel);
        self.schedulePreviousLegDateLabel = ko.observable(leg.SchedulePreviousLegDateLabel);
        
        self.hasParentAction = ko.observable(false);

        // TODO: set up "cancel"
      }
    }

    if (leg.isInlineForm) {
      self.scheduleTitle = ko.observable(leg.ScheduleTitle);
      self.scheduleDescription = ko.observable(leg.ScheduleDescription);
      self.scheduleLocationTitle = ko.observable(leg.ScheduleLocationTitle);
      self.scheduleLocationDescription = ko.observable(leg.ScheduleLocationDescription);
      self.postalCodeLabel = ko.observable(leg.PostalCodeLabel);
      self.postalCodeValidationText = ko.observable(leg.PostalCodeValidationText);
      self.addressEmptyValidationText = ko.observable(leg.AddressEmptyValidationText);
      self.addressOutsideLocalMarketValidationText = ko.observable(leg.AddressOutsideLocalMarketValidationText);
      self.addressOutsideLocalMarketErrorText = ko.observable(leg.AddressOutsideLocalMarketErrorText);
      self.postalCodeOutsideServiceAreaValidationText = ko.observable(leg.PostalCodeOutsideServiceAreaValidationText);
      self.streetAddress1Label = ko.observable(leg.StreetAddress1Label);
      self.streetAddress2Label = ko.observable(leg.StreetAddress2Label);
      self.optionalLabel = ko.observable(leg.OptionalLabel);
      self.cityLabel = ko.observable(leg.CityLabel);
      self.stateLabel = ko.observable(leg.StateLabel);
      self.dateLabel = ko.observable(leg.DateLabel);
      self.dateInformation = ko.observable(leg.DateInformation);
      self.confirmButtonLabel = ko.observable(leg.ConfirmButtonLabel);
      self.cancelButtonLabel = ko.observable(leg.CancelButtonLabel);
      self.dateHelperLabel = ko.observable(leg.DateHelperLabel);
      self.additionalChargeConfirmationMessageText = ko.observable(leg.AdditionalChargeConfirmationMessageText);
      self.refundConfirmationMessageText = ko.observable(leg.RefundConfirmationMessageText);
      self.confirmationButtonText = ko.observable(leg.ConfirmationButtonText); 
      self.disableWindow = ko.observable(leg.DisableWindow);  
      self.reschedulingWindow = ko.observable(leg.ReschedulingWindow);
    }

    if (leg.MoveLegKnockoutTemplateName === 'inlineform-ml-template') {
      self.legAddress1 = ko.observable(leg.Address.Address1);
      self.legAddress2 = ko.observable(leg.Address.Address2);
      self.legCity = ko.observable(leg.Address.City);
      self.legState = ko.observable(leg.Address.State);
      self.legPostalCode = ko.observable(leg.Address.PostalCode);
      self.legCountry = ko.observable(leg.Address.Country);
    }

    if (leg.MoveLegKnockoutTemplateName === 'scheduleform-ml-template' || leg.MoveLegKnockoutTemplateName === 'visitform-ml-template' || leg.isScheduleForm) {
      self.schedulingRuleCanSchedule = ko.observable(leg.SchedulingRule.CanSchedule);
      self.schedulingRuleStartDate = ko.observable(leg.SchedulingRule.ScheduleStart);
      self.schedulingRuleEndDate = ko.observable(leg.SchedulingRule.ScheduleEnd);

      if (leg.SchedulingRule.CanSchedule) {
        self.editDetailsCtaText = ko.observable(leg.EditDetailsCtaText);
      }
    }

    if (leg.isContainerPlacement) {
      self.icpTitle = ko.observable(leg.ContainerPlacement.Title);
      self.icpHelpText = ko.observable(leg.ContainerPlacement.HelpText);
      self.icpIconId = ko.observable(leg.ContainerPlacement.IconId);
      self.icpConfirmedMessage = ko.observable(leg.ContainerPlacement.ConfirmedMessage);
      self.icpImageAlt = ko.observable(leg.ContainerPlacement.ImageAlt);
      self.icpImageUrl = ko.observable(leg.ContainerPlacement.ImageUrl);
      self.icpCtaText = ko.observable(leg.ContainerPlacement.CtaText);
      self.icpValidationMessage = ko.observable(leg.ContainerPlacement.ValidationMessage);
    }

    if (leg.MoveLegKnockoutTemplateName === 'actionable-ml-template') {
      self.previousScheduledDateFormatted = ko.observable(leg.PreviousScheduledDateFormatted);
      if (leg.Action1MoveLeg) {
        self.action1CtaText = ko.observable(leg.Action1CtaText);
        self.action1MoveLeg = new ko_Legs(leg.Action1MoveLeg, container);
        self.action1MoveLeg.parentActionMoveLeg = self;
        self.action1MoveLeg.hasParentAction(true);

        self.toggleAction1 = (data, ev) => {
          ev.preventDefault();
          let targetLeg = self.action1MoveLeg;
          self.container.moveLegs.replace(self, targetLeg);
          feather.replace();
          addDatePicker();
          setupMoveLegSubmit();
        };
        self.action1MoveLeg.cancel = (data, ev) => {
          ev.preventDefault();
          let targetLeg = self.action1MoveLeg;
          self.container.moveLegs.replace(targetLeg, self);
          feather.replace();
        };
      }
      if (leg.Action2MoveLeg) {
        self.action2CtaText = ko.observable(leg.Action2CtaText);
        self.action2MoveLeg = new ko_Legs(leg.Action2MoveLeg, container);
        self.action2MoveLeg.parentActionMoveLeg = self;
        self.action2MoveLeg.hasParentAction(true);
        
        self.toggleAction2 = (data, ev) => {
          ev.preventDefault();
          let targetLeg = self.action2MoveLeg;
          self.container.moveLegs.replace(self, targetLeg);
          feather.replace();
          addDatePicker();
          setupMoveLegSubmit();
        };
        self.action2MoveLeg.cancel = (data, ev) => {
          ev.preventDefault();
          let targetLeg = self.action2MoveLeg;
          self.container.moveLegs.replace(targetLeg, self);
          feather.replace();
        };
      }
      
      self.handleSubmitActionableForm = (data, ev) => {
        ev.preventDefault();
        $("#CancelPickup .btn-primary").off('click').on('click', () => {
          console.log(ev);
          submitActionableForm($(ev.currentTarget).closest('.component-timeline_journey-card'));
          $("#CancelPickup").modal("hide");  
        });
        $("#CancelPickup").modal("show");
        
      }
      self.actionableState = ko.observable(leg.MoveLegType);
    }

    self.legStatusIcon = ko.computed(() => {
      let status = this.legStatus();
      let completedIcon = 'check-circle';
      let scheduledIcon = 'circle';

      if (status == 'Completed') {
        return completedIcon;
      }

      return scheduledIcon;
    });

    self.toggleForm = function (data, ev) {
      data.legFormVisible(true);
      data.legFormType((`${ev.currentTarget.dataset.formType}-leg-form`).toLowerCase());
      feather.replace();
    };

    self.inProgress = function ($parent, e) {
      $(e.currentTarget).parentsUntil('.component-timeline_journey-card').parent().addClass('InProgress');
      return true;
    };
  }
};

// Container Placement Observables Definition

let ko_ContainerPlacement = function (containers) {
  let self = this;

  if (containers) {
    self.ModalTitle = ko.observable(containers.ModalTitle);
    self.CurrentStepId = ko.observable(containers.CurrentStepId);
    self.PreviousStepId = ko.observable(containers.PreviousStepId);
    self.QuestionText = ko.observable(containers.QuestionText);
    self.HelpText = ko.observable(containers.HelpText);
    self.ImageSrc = ko.observable(containers.ImageSrc);
    self.ImageAlt = ko.observable(containers.ImageAlt);
    self.BackButtonText = ko.observable(containers.BackButtonText);
    self.NextButtonText = ko.observable(containers.NextButtonText);
    self.FinishButtonText = ko.observable(containers.FinishButtonText);
    self.isRadioOnly = ko.observable(containers.IsRadioOnly);
    self.isImageAnswers = ko.observable(containers.IsImageAnswers);
    self.isPodsTip = ko.observable(containers.IsPodsTip);
    self.isTextArea = ko.observable(containers.IsTextArea);
    self.isLastStep = ko.observable(containers.IsLastStep);
    self.Answers = ko.observable(containers.Answers);
    self.PodsTip = ko.observable(containers.PodsTip);
    self.PodsTipIcon = ko.observable(containers.PodsTip.IconSrc);
    self.PodsTipIconAlt = ko.observable(containers.PodsTip.IconAlt);
    self.PodsTipTitle = ko.observable(containers.PodsTip.TitleText);
    self.PodsTipHelptext = ko.observable(containers.PodsTip.HelpText);
    self.isContainerReviewPanel = ko.observable(containers.IsContainerReviewPanel);
    self.ContainerReviewPanel = ko.observable(containers.ContainerReviewPanel);
    self.ContainerReviewPanelSubTitle = ko.observable(containers.ContainerReviewPanel.SubTitle);
    self.ContainerReviewPanelType = ko.observable(containers.ContainerReviewPanel.Type);
    self.ContainerReviewPanelPlacementTitle = ko.observable(containers.ContainerReviewPanel.PlacementTitle);
    self.ContainerReviewPanelPlacementImg = ko.observable(containers.ContainerReviewPanel.PlacementImg);
    self.ContainerReviewPanelPlacementImgAlt = ko.observable(containers.ContainerReviewPanel.PlacementImgAlt);
    self.ContainerReviewPanelInstructionTitle = ko.observable(containers.ContainerReviewPanel.InstructionTitle);
    self.ContainerReviewPanelInstructionText = ko.observable(containers.ContainerReviewPanel.InstructionText);
    self.isMultiselectPanel = ko.observable(containers.IsMultiselectPanel);
    self.MultiselectPanel = ko.observable(containers.MultiselectPanel);
    self.ZipRegulations = ko.observable(containers.ZipRegulations);
    self.enablefinish = ko.observable(false);
    self.TotalSteps = ko.observable(containers.TotalSteps);
    self.CurrentQuestion = ko.observable(1);

    self.Width = ko.computed(function() {
      var progress = 0;
      progress = parseInt(100 * currentStep / self.TotalSteps());
      (progress > 100) && (progress = 100);
      var result = String(progress) + '%'; //css width property
      return result;
    });
  }
};

// Container Placement function to collect Data

function generateContainerPlacement (placeObj) {
  if (placeObj) {
    placeObj.forEach((place) => {
      const i = new ko_ContainerPlacement(place);
      containerTimelineJourneyVM.Steps.push(i);
    });
  }
}

function generateContainers(orderObj) {
  containerTimelineJourneyVM.Containers.removeAll();

  orderObj.forEach(oOrder => {
    oOrder.Containers.forEach(oContainer => {
      let i = new ko_Container(oContainer);
      let lastMoveLeg;

      oContainer.MoveLegs.forEach((leg) => {
        let currentleg = new ko_Legs(leg, i);
        i.moveLegs.push(currentleg);

        // Save next move leg
        if (lastMoveLeg)lastMoveLeg.nextMoveLeg = currentleg;

        // Update last move leg
        lastMoveLeg = currentleg;
      });

      containerTimelineJourneyVM.Containers.push(i);
    });
  });
}

function handleMoveLegSubmissionResponse(moveLeg, data) {
  if (data) {
    if (data.Success == true && data.RequiresConfirmation == true) {
      // Show confirmation message
      let confirmationMessageTag = moveLeg.find('.confirmation-texts');
      if (data.PriceDifference < 0) {
        confirmationMessageTag.html(confirmationMessageTag.attr('data-refundConfirmationMessageText').replace('{PriceDifference}', (data.PriceDifference * -1)));
      } else {
        confirmationMessageTag.html(confirmationMessageTag.attr('data-additionalChargeConfirmationMessageText').replace('{PriceDifference}', data.PriceDifference));
      }
      confirmationMessageTag.removeClass('d-none');
      
      // Update button text
      let confirmationButtonTag = moveLeg.find('.submitForm');
      confirmationButtonTag.html(confirmationMessageTag.attr('data-confirmationButtonText'));

      // Attach Quote ID
      moveLeg.attr('data-quoteId', data.QuoteId);

      // Flip panels
      moveLeg.find('.book-loading').addClass('d-none');
      moveLeg.find('.progress-content.showEdit').removeClass('d-none')
    } else if (data.Success == true) {
      moveLeg.find('.book-loading').addClass('d-none');
      moveLeg.find('.book-booked').removeClass('d-none');

      setTimeout(function () {
        if (data.Orders) {
          // Adding google analytics
          _ga.pushMoveLegSubmit(moveLeg.attr('data-legId'), window.customerOrders.Orders, data.Orders, window.customerOrders.UserId);

          window.customerOrders = data;
  
          var flag = false;
          refreshContainers(flag); // Need to re-get the moveLeg now that we've refreshed the containers and re-show the loading markup
  
          moveLeg = $('[data-legid=' + moveLeg.attr('data-legId') + ']');        
        }
        moveLeg.find('.book-booked').addClass('d-none');
      }, 1000);
    } else {
      moveLeg.find('.book-loading').addClass('d-none');
      let errorContainer = moveLeg.find('.book-error');
      errorContainer.removeClass('d-none');

      // Wire up the "try again" button to re-show the edit screen
      errorContainer.find("a.try-again").off("click").on("click", function(e) {
        e.preventDefault();
        $(this).closest('.component-timeline_journey-card.active').find('.progress-content.showEdit').removeClass('d-none');
        errorContainer.addClass('d-none');
      });
      _ga.pushMoveLegError(moveLeg.attr('data-legType'), data.NotificationTitle, data.FriendlyErrorMessage, data.ExceptionMessage, window.customerOrders.UserId);
    }

    // Once Container placement journey is done and successful, reset the progress and make the StepCheck back to false.
    currentStep = 0;
    finishStepCheck = false;
  } else {
    showNotification('error', 'Error submitting move leg');
    _ga.pushMoveLegError(moveLeg.attr('data-legType'), "handleMoveLegSubmissionResponse", "No data return for leg: " + moveLeg.attr('data-legType'), "", window.customerOrders.UserId);
  }
}

function submitScheduleForm(moveLeg, clickTarget) {
  var containerDatasourceId = moveLeg.closest('.component-timeline').attr('data-datasourceId');
  const container = moveLeg.closest('.component-timeline_journey');
  const orderId = container.attr('data-orderId');
  const containerId = container.attr('data-containerId');
  var legId = moveLeg.attr('data-legId');
  var legType = moveLeg.attr('data-legType');
  var requestedDate = moveLeg.find('.datepicker').val();
  var legTransitDays = moveLeg.attr('data-legTransitDays');
  var quoteId = moveLeg.attr('data-quoteId');
  var isCancelLeg = clickTarget.attr('data-isCancelLeg') == "true";
  var warehouseCode = moveLeg.attr('data-warehouseCode');

  $.ajax({
    type: 'POST',
    url: '/api/sitecore/Orders/SubmitMoveLeg',
    contentType: 'application/json',
    dataType: 'json',
    cache: false,
    data: JSON.stringify({
      'ContainerDatasourceId': containerDatasourceId,
      'OrderId': orderId,
      'ContainerId': containerId,
      // "CustomerId":"<username>", // This will be populated by BED code before sending to Locum
      'MoveLegId': legId, //ServiceId
      'MoveLegType': legType, //ServiceType
      'RequestedDate': requestedDate,
      // No address needed to submit because Locum already knows it
      // Transit Days only required for WTW leg, other legs will ignore value
      'TransitDays': isNaN(legTransitDays) ? 0 : parseInt(legTransitDays),
      'QuoteId': quoteId,
      'IsCancelLeg': isCancelLeg,
      'SiteIdentity': warehouseCode
    }),
    beforeSend: function() {
      moveLeg.find('.book-loading').removeClass('d-none');
    },
    success: function(data) {
      handleMoveLegSubmissionResponse(moveLeg, data);
    },
    error: function(data, textStatus, errorThrown) {
      console.error('error getting data', textStatus, errorThrown);
      _ga.pushMoveLegError(legType, "submitScheduleForm", textStatus, errorThrown, window.customerOrders.UserId);
    }
  });
}

function submitInlineForm(moveLeg, clickTarget) {
  var containerDatasourceId = moveLeg.closest('.component-timeline').attr('data-datasourceId');
  const container = moveLeg.closest('.component-timeline_journey');
  const orderId = container.attr('data-orderId');
  const containerId = container.attr('data-containerId');
  const legId = moveLeg.attr('data-legId');
  const legType = moveLeg.attr('data-legType');
  const quoteId = moveLeg.attr('data-quoteId');
  const isCancelLeg = moveLeg.attr('data-isCancelLeg') == "true";
  const warehouseCode = moveLeg.attr('data-warehouseCode');
  const requestedDate = moveLeg.find('.datepicker').val();

  const form = moveLeg.find('.inlineForm');
  const address1 = $(form).find('.Address1').val();
  const address2 = $(form).find('.Address2').val();
  const city = $(form).find('.City').val();
  const state = $(form).find('.State').val();
  const zipCode = $(form).find('.ZipCode').val();
  const countryCode =  $(form).find('.RegionCode').val();

  $.ajax({
    type: 'POST',
    url: '/api/sitecore/Orders/SubmitMoveLeg',
    contentType: 'application/json',
    dataType: 'json',
    cache: false,
    data: JSON.stringify({
      'ContainerDatasourceId': containerDatasourceId,
      'OrderId': orderId,
      'ContainerId': containerId,
      //"CustomerId":"<username>", //this will be populated by BED code before sending to Locum
      'MoveLegId': legId, //ServiceId
      'MoveLegType': legType,   //ServiceType
      'RequestedDate': requestedDate,
      'ServiceAddress': {
        'Address1': address1,
        'Address2': address2,
        'City': city,
        'State': state,
        'PostalCode': zipCode,
        'Country': countryCode
      },
      'ContainerPlacement': finalArray,
      'QuoteId': quoteId,
      'IsCancelLeg': isCancelLeg,
      'SiteIdentity': warehouseCode
    }),
    beforeSend: function() {
      moveLeg.find('.book-loading').removeClass('d-none');
    },
    success: function(data) {
      handleMoveLegSubmissionResponse(moveLeg, data);
    },
    error: function(data, textStatus, errorThrown) {
      console.error('Error getting data', textStatus, errorThrown);
      _ga.pushMoveLegError(legType, "submitInlineForm", textStatus, errorThrown, window.customerOrders.UserId);
    }
  });
}

function populateCities(form, cities, state, regionCode) {
  var citiesDropdown = $(form).find('.City');
  var stateField = $(form).find('.State');
  var regionCodeField = $(form).find('.RegionCode');

  citiesDropdown.html('');

  $(cities).each(function (index, element) {
    citiesDropdown.append(`<option value='${element}'>${element}</option>`);
    $(citiesDropdown).trigger('chosen:updated');
  });

  if (cities.length > 1) {
    citiesDropdown.prop('disabled', false);
  }

  stateField.val(state);
  regionCodeField.val(regionCode);
}

function enableContainerPlacement(postalCodeElement) {
  //   $(postalCodeElement).closest(".component-timeline_journey-card").find("#containerplacementModal").removeClass("disabled");
  $(postalCodeElement).closest('.component-timeline_journey-card').find('[data-id=containerplacementModal]').removeClass('disabled').prop('disabled', false);
}

function disableContainerPlacement(postalCodeElement) {
//   $(postalCodeElement).closest(".component-timeline_journey-card").find("#containerplacementModal").addClass("disabled");
  $(postalCodeElement).closest('.component-timeline_journey-card').find('[data-id=containerplacementModal]').addClass('disabled').prop('disabled', true);
}

function resetDatePicker(element) {
  const form = element.closest('.inlineForm');
  form.find('.datepicker').val('');
 
}

function isValidZip(zipCode) {
  return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode);
}

function setupAddressValidation() {
  $('.Address1').on('change', function (e) {
    $(this).removeClass('error');
    $(this).next().addClass('d-none');

    invalidateContainerPlacement();
    resetContainerPlacementButton();
    resetDatePicker($(this));

    //Add error message if address is empty

    if (!$(this).val()) {
      $(this).next().removeClass('d-none');
      $(this).addClass('error');
    }

    var datepicker = $('.component-timeline_journey-card.active').find('.datepicker');
    var zipCode = $('.component-timeline_journey-card.active').find('.ZipCode');

    if ($(this).val() && datepicker.val() && zipCode.val()) {
      enableContainerPlacement(zipCode);
    } else {
      disableContainerPlacement(zipCode);
    }
  });
}

// Checking if new address is in the same delivery area
function areInTheSameServiceArea(form) {
  const card = $(form).closest('.component-timeline_journey-card');
  const data = {
    'address1': {
      'Address1': card.attr('data-legAddress1'),
      'Address2': card.attr('data-legAddress2'),
      'City': card.attr('data-legCity'),
      'State': card.attr('data-legState'),
      'PostalCode': card.attr('data-legPostalCode'),
      'Country': card.attr('data-legCountry')
    },
    'address2': {
      'Address1': $(form).find('.Address1').val(),
      'Address2': $(form).find('.Address2').val(),
      'City': $(form).find('.City').val(),
      'State': $(form).find('.State').val(),
      'PostalCode': $(form).find('.ZipCode').val(),
      'Country': $(form).find('.RegionCode').val()
    }
  };

  $.ajax({
    url: '/api/sitecore/Orders/AreInTheSameServiceArea',
    type: 'POST',
    contentType: 'application/json',
    cache: false,
    data: JSON.stringify(data),
    success: function (result) {
      if (result.Success) {
        if (result.Response) {
          // Enabling datepicker
          $(form).closest('.component-timeline_journey-card').find('.datepicker').prop('disabled', false);
        }
        else {
          form.find('.error.outside-local-market').removeClass('d-none');
        }
      }
      if (!result.Success) {
        form.find('.error.outside-local-market-error').removeClass('d-none');
        console.error('Error getting Service Area: ' + result.NotificationTitle + ': ' + result.FriendlyErrorMessage);
      }
    },
    error: function(data, textStatus, errorThrown) {
      form.find('.error.outside-local-market-error').removeClass('d-none');
      console.error('Error getting data', textStatus, errorThrown);
    }
  });
}

function setupCityStateSubmit() {
  $('.ZipCode').attr('maxlength', 7); // Set maxlength

  $('.ZipCode').on('change', function (e) {
    invalidateContainerPlacement();
    resetContainerPlacementButton();
    resetDatePicker($(this));
    disableContainerPlacement($(this));

    var postalCodeElement = $(this);
    var form = postalCodeElement.closest('.inlineForm');

    // Hide postal code validation messages (we will show them again if necessary)
    form.find('.error.outside-local-market').addClass('d-none');
    form.find('.error.outside-local-market-error').addClass('d-none');
    form.find('.error.outside-service-area').addClass('d-none');

    postalCodeElement.next().addClass('d-none');
    postalCodeElement.removeClass('error');

    // Disabling datepicker
    $(form).closest('.component-timeline_journey-card').find('.datepicker').prop('disabled', true);

    var postalCode = postalCodeElement.val();
    var postalRegex = /^[0-9]{5}$|^[A-Z][0-9][A-Z] ?[0-9][A-Z][0-9]$/;

    if (!postalCode.length > 0 || !postalRegex.test(postalCode)) {
      postalCodeElement.next().removeClass('d-none');
      postalCodeElement.addClass('error');

      return false;
    }

    $.ajax({
      url: '/api/sitecore/Orders/DoCityStates?postalCode=' + postalCode,
      type: 'GET',
      contentType: 'application/json',
      success: function (result) {
        if (result.Cities && result.Cities.length > 0) {
          populateCities(form, result.Cities, result.State, result.RegionCode);
          areInTheSameServiceArea(form);
        }
        else if (result.FriendlyErrorMessage && result.NotificationTitle) {
          console.error('Error getting City and State: ' + result.NotificationTitle + ': ' + result.FriendlyErrorMessage);
          if (result.ExceptionMessage) {
            console.error('Exception message: ' + result.ExceptionMessage);
          }
          // Show validation message because there are no cities or states
          form.find('.error.outside-service-area').removeClass('d-none');
        }
        else if (result.ExceptionMessage) {
          console.error('Error getting City and State: ' + result.ExceptionMessage);
          // Show validation message because there are no cities or states
          form.find('.error.outside-service-area').removeClass('d-none');
        }
      }
    });
  });
}

function setupGoogleApiAddressAutocomplete(){  
  var addressLine1Controls = $('.Address1');
  
  if (!addressLine1Controls || !addressLine1Controls.length) { console.debug("Unable to wire up Loqate address validation: can't find any Address1 controls"); return; }

  addressLine1Controls.each((i, addressLine1) => {
    // For each instance of address line 1 text fields, get the parent and find the corresponding address line 2 and zip code fields

    var moveLegCard = $(addressLine1).closest('.component-timeline_journey-card');

    if (!moveLegCard) {
      console.error("Unable to wire up Loqate address validation: Can't find the move leg card container");
      return;
    }

    var addressLine2 = moveLegCard.find('.Address2');
    if (!addressLine2 || !addressLine2.length) {
      console.error("Unable to wire up Loqate address validation: can't find the Address2 text input");
      return;
    }
    addressLine2 = addressLine2[0];
    
    var zipCode = moveLegCard.find('.ZipCode');
    if (!zipCode || !zipCode.length) {
      console.error("Unable to wire up Loqate address validation: can't find the ZipCode text input");
      return;
    }
    zipCode = zipCode[0];

    var moveLegId = moveLegCard.attr('data-legId');

    // Assign unique IDs for these controls (using the move leg ID) so they can be mapped with Loqate
    addressLine1.id = 'addressLine1-' + moveLegId;
    addressLine2.id = 'addressLine2-' + moveLegId;
    zipCode.id = 'zipCode-' + moveLegId;

    var fields = [
      { element: addressLine1.id, field: 'Line1' },
      { element: addressLine2.id, field: 'Line2', mode: pca.fieldMode.POPULATE },
      { element: zipCode.id, field: 'PostalCode', mode: pca.fieldMode.POPULATE }
    ];

    // $.registerLoqateControl(fields, window.globalLoqateOptions, zipCode.id);
    if (google != undefined) {
      let autocomplete = createAutocomplete(addressLine1.id);
      autocomplete.addListener("place_changed", () => fillAddress(autocomplete, fields));
    }

  });
}


function createAutocomplete(ctlAddress) {  
  let cntrl = document.querySelector("#" + ctlAddress);  
  let autocomplete = new google.maps.places.Autocomplete(cntrl, {
    componentRestrictions: { country: ["us", "ca"] },
    fields: ["address_components", "geometry"],
    types: ["address"],
  });
  return autocomplete;
}

function fillAddress(autocomplete, fields) {
  let place = autocomplete.getPlace();
  if (place) {

    let streetNumber = "";
		let streetName = "";
    let postcode="";    
    let  line1ControlId="";
    let  postalCodeControlId="";

    for(let ctl of fields){
      switch (ctl.field) {
        case "Line1": {
          line1ControlId=ctl.element;
        }
        case "PostalCode": {
          postalCodeControlId=ctl.element;
        }
      }
    }
    let currentPostalCode=$('#'+postalCodeControlId).value;
    for (let shipComp of place.address_components) {
      let shipCompType = shipComp.types[0];
				switch (shipCompType) {
          case "street_number": {
            streetNumber = `${shipComp.long_name}`;
            break;
          }
          case "route": {
            streetName = shipComp.short_name;
            break;
          }
          case "postal_code": {
            postcode = `${shipComp.long_name}`;
            break;
          }
        }
    }

    document.querySelector('#'+line1ControlId).value = [streetNumber, streetName].filter(Boolean).join(" ");
    document.querySelector('#' + postalCodeControlId).value = postcode;
    if(currentPostalCode!==postcode){
       // Fire the zip code search
       $(`#${postalCodeControlId}`).trigger('change');
    }
  }
}

function setupMoveLegSubmit() {
  $('.submitInlineForm').off().on('click', function () {
    if (!$(this).hasClass('disabled')) {
      let clickTarget = $(this);
      let moveLeg = clickTarget.closest('.component-timeline_journey-card');
      submitInlineForm(moveLeg, clickTarget);
      moveLeg.find('.progress-content.inlineForm').addClass('d-none');
    }
  });

  $('.submitScheduleForm').off().on('click', function () {
    if (!$(this).hasClass('disabled')) {
      let clickTarget = $(this);
      let moveLeg = clickTarget.closest('.component-timeline_journey-card');
      submitScheduleForm(moveLeg, clickTarget);
      moveLeg.find('.progress-content.showEdit').addClass('d-none');
    }
  });
}

  window.addEventListener('acornProcessStatus', receiveAcornProcessStatus, false);
  function receiveAcornProcessStatus(messageDataRec) {
    $("#acorn-mypods-widget").hide();
    let receivedData = messageDataRec.detail || ''
    let podsAction = 'None'
    if (receivedData && receivedData.acornProcessStatus) {
      if(window.customerOrders != undefined && window.customerOrders.FinanceSettings != undefined)
      {
        var financeSetting = window.customerOrders.FinanceSettings.filter(x => x.Status == receivedData.acornProcessStatus)[0];
        if (financeSetting != undefined) {
          $('#financestatus').html(financeSetting.Body);
          $('#financestatus').show();
          if (financeSetting.SurveyCode != '') {
            $('body').append(financeSetting.SurveyCode);
          }
        }        
      }
      if (receivedData.merAction === 'update') {
        podsAction = 'Update Quote with receivedData values (no offers, pending)'
      } else if (receivedData.merAction === 'add-payment-type' && receivedData.lenderNameSelected === 'Upgrade Indirect') {
        podsAction = 'Add Upgrade Payment Type and Update receivedData values'
      } else if (receivedData.merAction === 'add-payment-type' && receivedData.lenderNameSelected === 'Citi Pay') {
        podsAction = 'Add Citi Pay Payment Type and Update receivedData values'
      }
      podsAction = '<b>' + podsAction + '</b>'
    }
    console.log('receiveAcornProcessStatus', podsAction, receivedData.acornProcessStatus, receivedData.acornPostMessageKind, receivedData)
  }

$(function() {
  if (typeof delayTimelineInit === 'undefined' || !delayTimelineInit) {
    assignContainerTimelineJourneyVM();
    initContainerTimelineJourney();
    return;
  }

  $.ajax({
    url: '/api/sitecore/Orders/InitOrders?containerId=' + $('.component-timeline').attr('data-datasourceId'),
    type: 'GET',
    contentType: 'application/json',
    success: function (result) {
      window.customerOrders = result;
      console.log(customerOrders);
      $('.component-timeline-loader').hide();
      $('.component-timeline_container_wrapper').show();
      assignContainerTimelineJourneyVM();

      initContainerTimelineJourney();
      initContainerPlacement();
      init();
      initTimelineJourney();
    }
  });
});
